<template>
    <div>
        <div class="ppv2-w-full">
            <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                {{ $t('form_customer_v2.internal_notes.title') }}
            </h3>
        </div>

        <div class="p-0">
            <div class="ppv2-flex ppv2-flex-wrap ppv2-justify-center">
                <div class="ppv2-w-full">
                    <!-- Tabs -->
                    <ul
                        class="ppv2-pl-0 ppv2-flex ppv2-items-center ppv2-border-b ppv2-border-gray-200 ppv2-bg-transparent"
                        role="tablist"
                    >
                        <li v-for="(category, index) in noteCategories" :key="category.id">
                            <button
                                @click="selectTab(category.id)"
                                class="ppv2-px-4 ppv2-py-2 ppv2-text-sm poppinsMedium ppv2-border-b-2 ppv2-border-transparent hover:ppv2-border-blue-300"
                                :class="[
                                    isDark ? 'ppv2-text-white' : 'ppv2-text-[#0c2340]',
                                    { 'ppv2-border-blue-500 ppv2-text-blue-600': selectedTab === category.id },
                                ]"
                            >
                                {{ category.name }}
                            </button>
                        </li>

                        <li class="ppv2-ml-auto">
                            <button
                                @click="selectTab('settings')"
                                class="ppv2-px-4 ppv2-py-2 ppv2-text-sm ppv2-text-opacity-90 hover:ppv2-text-opacity-100"
                                :class="isDark ? 'ppv2-text-white' : 'ppv2-text-[#0c2340]'"
                            >
                                <i class="si si-settings"></i>
                                <span class="sr-only">Settings</span>
                            </button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="ppv2-rounded ppv2-p-4 ppv2-m-0">
                        <!-- Notes by category -->
                        <div v-for="category in noteCategories" :key="category.id" v-show="selectedTab === category.id">
                            <BaseTextarea
                                v-model="getNoteByCategoryId(category.id).content"
                                :placeholder="$t('form_customer_v2.internal_notes.placeholder')"
                            />
                            <div class="ppv2-d-flex ppv2-justify-content-between ppv2-align-items-center ppv2-my-4">
                                <BaseSwitch
                                    v-model="getNoteByCategoryId(category.id).is_important"
                                    :label="$t('form_customer_v2.internal_notes.important')"
                                />
                            </div>
                        </div>

                        <!-- Settings tab -->
                        <div
                            v-if="selectedTab === 'settings'"
                            class="text-center"
                            role="tabpanel"
                            aria-labelledby="btabs-alt-static-settings-tab"
                        >
                            {{ $t('form_customer_v2.internal_notes.setting') }}
                            <div
                                v-for="category in categories"
                                :key="category.id"
                                class="ppv2-px-4 ppv2-py-2 ppv2-text-sm poppinsMedium ppv2-border-b-2 ppv2-border-transparent hover:ppv2-border-blue-300"
                                :class="isDark ? 'ppv2-text-white' : 'ppv2-text-[#0c2340]'"
                            >
                                <div class="ppv2-w-1/2 ppv2-p-1">
                                    <BaseInput v-model="category.name" required />
                                </div>
                            </div>
                            <div
                                class="ppv2-flex ppv2-justify-center ppv2-flex-wrap"
                                :style="{
                                    gap: normalizeSize(16, true),
                                    paddingLeft: normalizeSizeVertical(24, true),
                                    paddingRight: normalizeSizeVertical(24, true),
                                    marginTop: normalizeSizeVertical(20, true),
                                    marginBottom: normalizeSizeVertical(20, true),
                                }"
                            >
                                <BaseButton id="reset" type="reset" variant="outline" customClass="reset">
                                    {{ $t('form_customer_v2.btn.reset') }}
                                </BaseButton>
                                <BaseButton id="submit" @click="updateCatgorie" type="button" variant="dark">
                                    {{ $t('form_customer_v2.btn.validate') }}
                                </BaseButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiManager from '../Api/v2/ApiManagerBoCutomer.js'
import BaseSwitch from '../../Shared/BaseSwitch.vue'
import BaseTextarea from '../../Shared/BaseTextarea.vue'
import BaseButton from '../../Shared/BaseButton.vue'
import BaseInput from '../../Shared/BaseInput.vue'

export default {
    props: ['user', 'noteCategories', 'userNoteCategories'],
    components: {
        BaseSwitch,
        BaseTextarea,
        BaseInput,
        BaseButton,
    },
    data() {
        return {
            selectedTab: this.noteCategories.length ? this.noteCategories[0].id : null,
            notes_internes: [],
            categories: this.noteCategories,
        }
    },
    computed: {
        isDark() {
            return this.theme.mode === 'dark'
        },
    },
    methods: {
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        selectTab(tabId) {
            this.selectedTab = tabId
        },
        getNoteByCategoryId(categoryId) {
            return (
                this.notes_internes.find((note) => note.note_category_id === categoryId) || { content: '', is_important: false }
            )
        },
        async submitNote() {
            const object_data = {
                notes: this.notes_internes,
                user_id: this.user.id,
            }

            try {
                const _data = await ApiManager.updateNote(JSON.stringify(object_data))
                this.notes_internes = _data.data.notes
                this.showMessageNotification(_data.message, 'success')
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
        async updateCatgorie() {
            try {
                const _data = await ApiManager.updateCatgorie(JSON.stringify(this.categories))
                this.categories = _data.data.categories
                this.showMessageNotification(_data.message, 'success')
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },
    },
    mounted() {
        this.noteCategories.forEach((category) => {
            const noteData = this.userNoteCategories[category.id]?.[0] ?? {}
            this.notes_internes.push({
                content: noteData.content || '',
                is_important: noteData.is_important === 1,
                user_id: this.user.id,
                note_category_id: category.id,
            })
        })
    },
}
</script>
